import { render, staticRenderFns } from "./LoaderRotation2.vue?vue&type=template&id=1ea8f532&scoped=true&"
import script from "./LoaderRotation2.vue?vue&type=script&lang=js&"
export * from "./LoaderRotation2.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRotation2.vue?vue&type=style&index=0&id=1ea8f532&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea8f532",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1ea8f532')) {
      api.createRecord('1ea8f532', component.options)
    } else {
      api.reload('1ea8f532', component.options)
    }
    module.hot.accept("./LoaderRotation2.vue?vue&type=template&id=1ea8f532&scoped=true&", function () {
      api.rerender('1ea8f532', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Loaders/LoaderRotation2.vue"
export default component.exports